import Geocomply from './lib/geocomply-client.min';

export default Geocomply;
